<template>
  <el-form
    :model="form"
    ref="form">
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('region')"
          prop="regionID"
          :rules="getValidationRule('required')"
          class="material-style">
          <select-response
            :model.sync="form.regionID"
            @update:model="updateModelItem('regionID', { required: true })"
            :data="dataSourceRegions.records"
            :isLoading="dataSourceRegions.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('company')"
          :rules="getValidationRule('required')"
          prop="companyID"
          class="material-style">
          <select-company
            :model.sync="form.companyID"
            @update:model="updateModelItem('companyID', { required: true })"
          ></select-company>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('engine')"
          prop="engine"
          class="material-style">
          <el-input
            ref="seventhField"
            :value="form.engine"
            @input="form.engine = valueTrimLeft($event)"
            @change="updateModelItem('engine', { required: false })"
          />
        </el-form-item>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('unit')"
          prop="unit"
          class="material-style">
          <el-input
            ref="seventhField"
            :value="form.unit"
            @input="form.unit = valueNumber($event)"
            @change="updateModelItem('unit', { required: false })"
          />
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import Form from '@/components/Form/Form'

export default {
  name: 'FormFleets',
  mixins: [Form],
  components: {
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue')
  },
  computed: {
    dataSourceRegions () {
      return this.API('Regions/GetAllDynamic?select=id,title')
    }
  }
}
</script>
